import { render, staticRenderFns } from "./create-project.page.vue?vue&type=template&id=bf55f99a&scoped=true&"
import script from "./create-project.page.vue?vue&type=script&lang=js&"
export * from "./create-project.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf55f99a",
  null
  
)

export default component.exports